import styled from 'styled-components'

export const Styled = {
  FieldWrapper: styled.div`
    display: grid;
    gap: 0.5rem;
    max-width: 16.65rem;
  `,
  ForgotPasswordWrapper: styled.div`
    margin-top: 1.7rem;
    font-size: 0.875rem;

    a {
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }
  `,
  Block: styled.div`
    margin-top: 0.5rem;
  `,
}
